/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 *
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */

interface WarningTriangleIconProps {
  className?: string;
  width?: string | number;
  height?: string | number;
}

const WarningTriangleIcon = ({
  className,
  width = 150,
  height = 132,
}: WarningTriangleIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 150 132"
    fill="none"
    className={className}
  >
    <path
      d="M72.6562 15.605L14.6484 111.296C14.0625 112.179 14.0625 112.768 14.0625 113.651C14.0625 116.007 15.8203 117.773 18.1641 117.773H131.543C133.887 117.773 135.937 116.007 135.937 113.651C135.937 112.768 135.645 112.179 135.059 111.296L77.0508 15.605C76.7578 14.7217 75.8789 14.1328 75 14.1328C73.8281 14.1328 73.2422 14.7217 72.6562 15.605ZM60.6445 8.24414C63.5742 3.23877 69.1406 0 75 0C80.5664 0 86.1328 3.23877 89.0625 8.24414L147.07 103.935C148.828 106.879 150 110.118 150 113.651C150 123.662 141.797 131.906 131.543 131.906H18.1641C8.20312 131.906 0 123.662 0 113.651C0 110.118 0.878906 106.879 2.63672 103.935L60.6445 8.24414ZM84.375 98.9297C84.375 104.229 79.9805 108.352 75 108.352C69.7266 108.352 65.625 104.229 65.625 98.9297C65.625 93.9243 69.7266 89.5078 75 89.5078C79.9805 89.5078 84.375 93.9243 84.375 98.9297ZM82.0312 44.7539V73.0195C82.0312 77.1416 78.8086 80.0859 75 80.0859C70.8984 80.0859 67.9687 77.1416 67.9687 73.0195V44.7539C67.9687 40.9263 70.8984 37.6875 75 37.6875C78.8086 37.6875 82.0312 40.9263 82.0312 44.7539Z"
      fill="url(#paint0_linear_warning_triangle)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_warning_triangle"
        x1="75"
        y1="0"
        x2="75"
        y2="131.906"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="#494949" />
      </linearGradient>
    </defs>
  </svg>
);

export default WarningTriangleIcon;
